/**
 * The AS400 Header Cross upload's 82 fields, in column order (A…CD). These are
 * the field names AS400 gives them; Stelpro's RESULTS workbook carries them as
 * its headers verbatim (its columns Z…DC).
 */
export const AS400_UPLOAD_FIELDS = [
  'LOAD NUM',
  'LOAD TYPE',
  'TITLE',
  'LINE2',
  'D2FLG',
  'LINE3',
  'D3FLG',
  'START',
  'END',
  'AHADV',
  'ADVFLG',
  'ORD TYPE',
  'OTFLG',
  'AHCLAS',
  'AHCLFLG',
  'AHTERR',
  'AHTER',
  'ACCOUNT',
  'AHCUS',
  'GROUP',
  'CHGCGRP',
  'REF',
  'REFFLG',
  'REQUISITION#',
  'REQFLG',
  'PO',
  'CPFLG',
  'AHRRQN',
  'RRQFLG',
  'ATXOVR',
  'EXCHANGE',
  'EXCHFLG',
  'AHROLL',
  'AHSTAT',
  'HCCAD',
  'CHGHCCAD',
  'ADSEQ',
  'AS400 ITEM',
  'PC',
  'SC',
  'ADMIN',
  'ADMAX',
  'SELL NET',
  'SELL COL',
  'SELL DISC',
  'ADPONO',
  'ADRQNO',
  'ADSTAT',
  'STFLG',
  'ADCOST',
  'CORE COST NET',
  'ADTXFD',
  'ADFTXI',
  'ADFTXC',
  'ADFLIC',
  'PTP',
  'PTT',
  'ADPLIC',
  'ADCADJ',
  'ADTCOL',
  'ADTADJ',
  'CORE COST COL',
  'CORE COST DISC',
  'ROUNDUP',
  'ADQ1',
  'ADQ2',
  'ADQ3',
  'ADQ4',
  'ADQP1',
  'ADQP2',
  'ADQP3',
  'ADQP4',
  'ADQPC1',
  'ADQPC2',
  'ADQPC3',
  'ADQPC4',
  'ADQPA1',
  'ADQPA2',
  'ADQPA3',
  'ADQPA4',
  'COST ADD FIELD',
  'COST ADD FLAG',
] as const;

export type As400UploadField = (typeof AS400_UPLOAD_FIELDS)[number];
